import { Check, Dashboard, Space } from "../../types";
import { Colors, Metrics } from "../../resources";
import { FlatList, StyleSheet, View } from "react-native";

import { AxiosResponse } from "axios";
import React from "react";
import SChartListCard from "../molecules/SChartListCard";
import SListHeader from "../molecules/SListHeader";
import { useSpaces } from "../../hooks";

interface IProps {
  spaces: Space[];
  reports: any;
  updateCapacity: (
    id: string,
    capacity: number
  ) => Promise<AxiosResponse<any> | undefined>;
  updateSafeCapacity: (
    id: string,
    safeCapacity: number
  ) => Promise<AxiosResponse<any> | undefined>;
}

const SChartView: React.FC<IProps> = ({
  spaces,
  reports,
  updateCapacity,
  updateSafeCapacity,
}) => {
  const { checkSpace } = useSpaces();

  const renderChart = ({ item }: { item: any }) => {
    const onCheck = (check: Check) => {
      checkSpace(item.id, check === Check.Checked ? true : false);
    };

    return (
      <SChartListCard
        space={item}
        report={
          reports && reports[item.id] && reports[item.id]["daily"]
            ? reports[item.id]["daily"]
            : undefined
        }
        onCheck={onCheck}
        updateCapacity={updateCapacity}
        updateSafeCapacity={updateSafeCapacity}
      />
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.list}>
        <SListHeader type={Dashboard.Chart} />
        <FlatList
          data={spaces}
          renderItem={renderChart}
          keyExtractor={(space) => space.id}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
  },
  list: {
    flex: 1,
    marginTop: 35.5,
    marginHorizontal: Metrics.padding32,
  },
});

export default SChartView;
